<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    :placeInTop="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal d-modal--full-width text-dark" slot="insertComponent" @click.stop="closeFilters">
      <div class="d-modal__header">
        <h2>Se og rediger UV-grænser</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <Loader v-if="isLoading" :isLoaderModal="true"></Loader>
        <template v-else>
          <div class="uv-limits__toolbar">
            <div class="uv-limits__filters" @click.stop>
              <Tabs
                class="uv-limits__tabs"
                :tabs="[
                  {id: 'all', title: 'Alle'},
                  {id: 'with', title: 'Med UV-grænse (' + rowsWithTemplate + ')'},
                  {id: 'without', title: 'Uden UV-grænse (' + rowsWithoutTemplate + ')'}
                ]"
                :selected="templateTab"
                @select="templateTab = $event"
              ></Tabs>
              <DoFiltersFilter
                :title="'Personer'"
                :tags="uniqueNames"
                :selectedTags="selectedNames"
                :closeFromProp="closeFiltersCount"
                :numberOfSelectedTagsToShow="4"
                :placeholder="'Vælg personer'"
                @select="toggleName"
                @clear="clearNames"
              ></DoFiltersFilter>
              <DoFiltersFilter
                :title="'Grupper'"
                :tags="uniqueGroups"
                :selectedTags="selectedGroups"
                :closeFromProp="closeFiltersCount"
                :numberOfSelectedTagsToShow="4"
                :placeholder="'Vælg grupper'"
                @select="toggleGroup"
                @clear="clearGroups"
              ></DoFiltersFilter>
              <DoFiltersFilter
                :title="'Ansættelse'"
                :tags="uniqueEmploymentTitles"
                :selectedTags="selectedEmploymentTitles"
                :closeFromProp="closeFiltersCount"
                :numberOfSelectedTagsToShow="4"
                :placeholder="'Vælg ansættelser'"
                @select="toggleEmploymentTitle"
                @clear="clearEmploymentTitles"
              ></DoFiltersFilter>
            </div>
          </div>
          <div class="uv-limits__bulk-bar">
            <div class="uv-limits__bulk-bar-left">
            <button v-if="!isBulkMode" class="do-bttn do-bttn--submit" @click="enableBulkMode">
              Tildel stillingskategori til flere
            </button>
            <span v-if="!isBulkMode" @click.stop>
              <DDropdown
                :isShowDots="false"
                :propOffset="[0, 8]"
                :isBottomStart="false"
                :isCloseOnDropdownClick="true"
                :closeFromProp="closeFiltersCount"
              >
                <button class="do-bttn uv-limits__edit-templates-bttn" slot="title">
                  Rediger stillingskategorier
                  <span class="icon-menu-open"></span>
                </button>
                <div slot="list" class="uv-limits__templates-dropdown">
                  <ul class="uv-limits__templates-dropdown__list">
                    <li v-if="employmentTemplates.length === 0" class="italic">Ingen stillingskategorier oprettet</li>
                    <li
                      v-for="template in employmentTemplates"
                      :key="template.id"
                      class="uv-limits__templates-dropdown__item"
                      @click="openEditTemplate(template)"
                    >
                      <span class="uv-limits__templates-dropdown__item-title">
                        {{ template.title }}
                        <span class="uv-limits__templates-dropdown__item-limit">
                          UV-grænse: {{ template.hour_limit ? template.hour_limit : '—' }}
                        </span>
                      </span>
                      <div class="icon__bg-circle" title="Redigér UV-grænse og lønkode">
                        <span class="icon-pencil"></span>
                      </div>
                    </li>
                  </ul>
                  <div
                    class="uv-limits__templates-dropdown__create"
                    @click="openCreateTemplate"
                  >
                    <div class="btn-trans">
                      Opret stillingskategori
                    </div>
                  </div>
                </div>
              </DDropdown>
            </span>
            <p v-if="!isBulkMode" class="text-explainer uv-limits__explainer">
              UV-grænser og lønkoder sættes på stillingskategorierne. UV-timer vises fra tildelt undervisning.
            </p>
            <template v-else>
              <span class="text-explainer">{{ selectedCount }} valgt</span>
              <span v-if="selectedCount > 0" @click.stop>
                <DDropdown
                  :isShowDots="false"
                  :propOffset="[0, 8]"
                  :isBottomStart="true"
                  :isCloseOnDropdownClick="true"
                  :closeFromProp="closeFiltersCount"
                >
                  <button
                    slot="title"
                    class="do-bttn do-bttn--submit uv-limits__bulk-submit-bttn"
                    :class="{'do-bttn--submit--loading': isSavingBulkTemplates}"
                  >
                  Vælg stillingskategori til {{ selectedCount }} <span class="icon-menu-open"></span>
                  </button>
                  <ul slot="list">
                    <li v-if="employmentTemplates.length === 0" class="italic">Ingen stillingskategorier oprettet</li>
                    <li
                      v-for="template in employmentTemplates"
                      :key="template.id"
                      @click="assignTemplateToSelected(template)"
                    >
                      {{ templateOptionLabel(template) }}
                    </li>
                  </ul>
                </DDropdown>
              </span>
              <button
                v-else
                class="do-bttn do-bttn--submit do-bttn--submit--disabled uv-limits__bulk-submit-bttn"
                content="Vælg personer først"
                v-tippy="{
                  arrow: true,
                  placement: 'top',
                  animateFill: false,
                  animation: 'shift-away',
                  boundary: 'window',
                  zIndex: 12312312312312
                }"
              >
                Vælg stillingskategori til de valgte <span class="icon-menu-open"></span>
              </button>
              <button class="do-bttn" @click="disableBulkMode">
                Annuller
              </button>
            </template>
          </div>
          <span
            v-if="tidsbegraensetCount > 0"
            class="do-badge do-badge--yellow"
            :content="tidsbegraensetCount + (tidsbegraensetCount === 1 ? ' ansættelse har' : ' ansættelser har') + ' en afvigende periode med UV-timer. Klik på \'Beregn timer\' for at danne et UV-tillæg for perioden.'"
            v-tippy="{
              arrow: true,
              placement: 'bottom',
              animateFill: false,
              animation: 'shift-away',
              boundary: 'window',
              zIndex: 12312312312312
            }"
          >
            <span class="icon-warning"></span>
            {{ tidsbegraensetCount }} {{ tidsbegraensetCount === 1 ? 'ansættelse' : 'ansættelser' }} med afvigende periode
          </span>
          </div>

          <div class="uv-limits__table-scroll">
          <table class="do-table do-table--striped">
            <thead>
            <tr>
              <th
                v-if="isBulkMode"
                class="uv-limits__select-cell"
                @click="toggleAllVisibleEmployments"
              >
                <div class="do-checkbox" :class="{'do-checkbox--selected': areAllVisibleEmploymentsSelected}"></div>
              </th>
              <th>Navn</th>
              <th>Stillingskategori</th>
              <th>UV-grænse</th>
              <th>Lønkode</th>
              <th v-if="showSpecialSkoleSalaryCodeColumn">Spec-skole lønkode</th>
              <th
                class="uv-limits__narrow uv-limits__sortable"
                :class="{'uv-limits__sortable--active': uvHoursSort}"
                @click="toggleUvHoursSort"
              >
                UV-timer
                <span
                  class="icon-menu-open uv-limits__sort-icon"
                  :class="{
                    'uv-limits__sort-icon--asc': uvHoursSort === 'asc',
                    'uv-limits__sort-icon--muted': !uvHoursSort
                  }"
                ></span>
              </th>
              <th>Ansættelse</th>
              <th v-if="isSalaryIntegrationActive">Ansættelsesnummer</th>
              <th class="uv-limits__narrow">Lønbrøk</th>
              <th class="uv-limits__narrow">Bruttotid</th>
              <th>Startdato</th>
              <th>Slutdato</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="filteredRows.length === 0">
              <td :colspan="emptyColspan"><i>Ingen personer matcher filtrene</i></td>
            </tr>
            <tr
              v-for="row in filteredRows"
              :key="row.key"
              :class="{'uv-limits__row--selectable': isBulkMode && isSelectableRow(row), 'is-selected': isBulkMode && isRowSelected(row), 'uv-limits__row--inactive': !row.employment && isSalaryIntegrationActive}"
              @click="isBulkMode && toggleRow(row)"
            >
              <td v-if="isBulkMode" class="uv-limits__select-cell">
                <div
                  class="do-checkbox"
                  v-if="row.employment"
                  :class="{'do-checkbox--selected': isEmploymentSelected(row.employment.id)}"
                ></div>
                <div
                  class="do-checkbox"
                  v-if="!row.employment && !isSalaryIntegrationActive"
                  :class="{'do-checkbox--selected': isUserWithoutEmploymentSelected(row.user.id)}"
                ></div>
              </td>
              <td>
                <strong>{{ row.user.name }}</strong>
                <span
                  v-if="hasDataIssues(row.user.id)"
                  class="uv-limits__warning"
                  :content="dataIssuesTitle(row.user.id)"
                  v-tippy="{
                    arrow: true,
                    placement: 'right',
                    animateFill: false,
                    animation: 'shift-away',
                    boundary: 'window',
                    zIndex: 12312312312312
                  }"
                >
                  <span class="icon-warning"></span>
                </span>
              </td>
              <td @click.stop>
                <div class="uv-limits__template-cell">
                  <select
                    v-if="row.employment"
                    class="do-select width-100"
                    :value="row.employment.employment_template_id || ''"
                    @change="setEmploymentTemplate(row.employment, $event.target.value)"
                  >
                    <option value=""></option>
                    <option v-for="template in employmentTemplates" :key="template.id" :value="template.id">
                      {{ templateOptionLabel(template) }}
                    </option>
                  </select>
                  <select
                    v-else-if="!isSalaryIntegrationActive"
                    class="do-select width-100"
                    @change="createEmploymentForUser(row.user, $event.target.value)"
                  >
                    <option disabled selected value=""></option>
                    <option v-for="template in employmentTemplates" :key="template.id" :value="template.id">
                      {{ templateOptionLabel(template) }}
                    </option>
                  </select>
                  <span v-else class="muted">—</span>
                </div>
                <div
                  v-if="row.employment && row.isLastForUser && !isSalaryIntegrationActive"
                  class="uv-limits__add-employment"
                >
                  <select
                    v-if="addingForRowKey === row.key"
                    class="do-select width-100"
                    @change="createEmploymentForUser(row.user, $event.target.value); addingForRowKey = null"
                  >
                    <option disabled selected value="">Vælg stillingskategori</option>
                    <option v-for="template in employmentTemplates" :key="template.id" :value="template.id">
                      {{ templateOptionLabel(template) }}
                    </option>
                  </select>
                </div>
              </td>
              <td>{{ row.template && row.template.hour_limit ? row.template.hour_limit : '—' }}</td>
              <td>{{ row.template && row.template.hour_limit_salary_code_id ? salaryCodeLoenart(row.template.hour_limit_salary_code_id) : '—' }}</td>
              <td v-if="showSpecialSkoleSalaryCodeColumn">{{ row.template && row.template.special_hour_limit_salary_code_id ? salaryCodeTitle(row.template.special_hour_limit_salary_code_id) : '—' }}</td>
              <td class="uv-limits__narrow">{{ formatDecimal(assignedTeachingHours(row.user.id)) }}</td>
              <td class="uv-limits__secondary">{{ row.employment ? employmentTitle(row.employment) : 'Ingen aktive ansættelser' }}</td>
              <td v-if="isSalaryIntegrationActive" class="uv-limits__secondary">{{ row.employment && row.employment.employment_number ? row.employment.employment_number : '—' }}</td>
              <td class="uv-limits__narrow uv-limits__secondary" :class="{'uv-limits__missing': ansaettelsesgradIssue(row.user.id)}">
                <template v-if="ansaettelsesgradIssue(row.user.id)">Mangler</template>
                <template v-else>{{ formatDecimal(weeklyHours(row.user.id)) }}</template>
              </td>
              <td class="uv-limits__narrow uv-limits__secondary" :class="{'uv-limits__missing': bruttotidIssue(row.user.id)}">
                <template v-if="bruttotidIssue(row.user.id)">Mangler</template>
                <template v-else>{{ formatDecimal(bruttoTime(row.user.id)) }}</template>
              </td>
              <td class="uv-limits__secondary" :class="{'uv-limits__missing': startDateIssue(row.user.id), 'uv-limits__deviant': isTidsbegraensetRow(row) && startIsDeviant(row)}">
                <template v-if="startDateIssue(row.user.id)">Mangler</template>
                <template v-else>{{ formatDate(periodStart(row.user.id)) }}</template>
              </td>
              <td class="uv-limits__secondary" :class="{'uv-limits__missing': endDateIssue(row.user.id), 'uv-limits__deviant': isTidsbegraensetRow(row) && endIsDeviant(row)}">
                <template v-if="endDateIssue(row.user.id)">Mangler</template>
                <template v-else>{{ formatDate(periodEnd(row.user.id)) }}</template>
              </td>
              <td class="uv-limits__actions-cell" @click.stop>
                <button
                  v-if="isTidsbegraensetRow(row)"
                  class="do-bttn uv-limits__beregn-bttn"
                  @click="openBeregn(row)"
                  content="Afvigende periode (ikke 1/8 – 31/7). Beregn UV-tillæg for den faktiske periode og dan et supplement i listen."
                  v-tippy="{
                    arrow: true,
                    placement: 'left',
                    animateFill: false,
                    animation: 'shift-away',
                    boundary: 'window',
                    zIndex: 12312312312312
                  }"
                >
                  <span class="icon-warning"></span> Beregn timer
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          </div>
        </template>
      </div>

      <div class="d-modal__buttons">
        <button class="do-bttn" @click="$emit('close')">Luk</button>
      </div>

      <DoEmploymentTemplate
        v-if="isTemplateModalOpen"
        :theEditEmploymentTemplate="editTemplate"
        :forceHourLimitMode="true"
        @created="onTemplateSaved"
        @updated="onTemplateSaved"
        @close="closeTemplateModal"
      />

      <UvLimitTidsbegraensetModal
        v-if="beregnRow"
        :schoolId="schoolId"
        :schoolYearId="schoolYearId"
        :userId="beregnRow.user.id"
        :userName="beregnRow.user.name"
        :employmentId="beregnRow.employment.id"
        :ansaettelsesgradPercent="employmentPercentage(beregnRow.user.id)"
        :yearNormHours="bruttoTime(beregnRow.user.id)"
        :periodStart="periodStart(beregnRow.user.id)"
        :periodEnd="periodEnd(beregnRow.user.id)"
        :assignedTeachingHours="assignedTeachingHours(beregnRow.user.id)"
        :initialGraense="beregnRow.template ? beregnRow.template.hour_limit : null"
        :salaryCodeId="beregnRow.template ? beregnRow.template.hour_limit_salary_code_id : null"
        @created="onBeregnCreated"
        @close="beregnRow = null"
      />
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal.vue'
import Loader from '../common/Loader.vue'
import DoEmploymentTemplate from '../Salary/SalarySettings/DoEmploymentTemplate.vue'
import UvLimitTidsbegraensetModal from './UvLimitTidsbegraensetModal.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import DDropdown from '../common/DDropdown.vue'
import Tabs from '../common/Tabs.vue'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import moment from 'moment'

export default {
  components: {DModal, DoEmploymentTemplate, UvLimitTidsbegraensetModal, DoFiltersFilter, DDropdown, Loader, Tabs},
  props: {
    schoolId: {
      default: () => null
    },
    schoolYearId: {
      default: () => null
    }
  },
  data () {
    return {
      isLoadingUserYears: false,
      userYears: [],
      isTemplateModalOpen: false,
      editTemplate: null,
      isSavingTemplateId: null,
      selectedNames: [],
      selectedGroups: [],
      selectedEmploymentTitles: [],
      selectedEmploymentIds: [],
      selectedUserIdsWithoutEmployments: [],
      isSavingBulkTemplates: false,
      isSavingNewEmploymentUserId: null,
      closeFiltersCount: 0,
      isBulkMode: false,
      templateTab: 'all',
      addingForRowKey: null,
      teachingHoursMap: {},
      isLoadingTeachingHours: false,
      employmentsLoadedOnce: false,
      beregnRow: null,
      uvHoursSort: null
    }
  },
  computed: {
    isSalaryIntegrationActive () {
      const features = this.$store.getters.schoolFeatures || []
      return features.indexOf('kmd_opus_integration') > -1 || features.indexOf('silkeborg_data_integration') > -1
    },
    poolsDeactivated () {
      const settings = this.$store.state.schoolSettings
      return !!(settings && settings.deactivatePools)
    },
    emptyColspan () {
      let count = this.showSpecialSkoleSalaryCodeColumn ? 12 : 11
      if (this.isBulkMode) count++
      if (this.isSalaryIntegrationActive) count++
      return count
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    employmentsInUserIdHash () {
      return this.$store.getters.employmentsInUserIdHash
    },
    employmentTemplates () {
      return this.$store.getters.employmentTemplatesSorted
    },
    showSpecialSkoleSalaryCodeColumn () {
      // Spec-skole uv-tillæg er midlertidigt skjult for SD.
      if (this.$store.getters.salarySystem === 'SD') return false
      return this.employmentTemplates.some(template => template.special_hour_limit_salary_code_id != null && template.special_hour_limit_salary_code_id !== '')
    },
    employmentTemplateMap () {
      const map = {}
      this.employmentTemplates.forEach(template => {
        map[template.id] = template
      })
      return map
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted
    },
    salaryCodeMap () {
      const map = {}
      this.salaryCodes.forEach(salaryCode => {
        map[salaryCode.id] = salaryCode.vTitle
      })
      return map
    },
    userYearMap () {
      const map = {}
      this.userYears.forEach(userYear => {
        map[userYear.user_id] = userYear
      })
      return map
    },
    rows () {
      const rows = []
      this.users.forEach(user => {
        const employments = (this.employmentsInUserIdHash[user.id] || [])
          .filter(employment => !employment.deleted)
          .sort((a, b) => this.employmentTitle(a).localeCompare(this.employmentTitle(b), 'da-DK'))

        if (employments.length < 1) {
          rows.push({
            key: 'user-' + user.id + '-no-employment',
            user: user,
            employment: null,
            template: null
          })
          return
        }

        employments.forEach((employment, index) => {
          rows.push({
            key: 'employment-' + employment.id,
            user: user,
            employment: employment,
            template: this.employmentTemplateMap[employment.employment_template_id] || null,
            isLastForUser: index === employments.length - 1
          })
        })
      })
      return rows
    },
    filteredRows () {
      const rows = this.rows.filter(row => this.matchesFilters(row.user) && this.matchesEmploymentTitle(row) && this.matchesTemplateTab(row))
      if (!this.uvHoursSort) return rows
      const dir = this.uvHoursSort === 'asc' ? 1 : -1
      return rows.slice().sort((a, b) => {
        const aHours = parseFloat(this.assignedTeachingHours(a.user.id)) || 0
        const bHours = parseFloat(this.assignedTeachingHours(b.user.id)) || 0
        return (aHours - bHours) * dir
      })
    },
    rowsWithTemplate () {
      return this.rows.filter(row => this.matchesFilters(row.user) && this.matchesEmploymentTitle(row) && this.rowHasTemplate(row)).length
    },
    rowsWithoutTemplate () {
      return this.rows.filter(row => this.matchesFilters(row.user) && this.matchesEmploymentTitle(row) && !this.rowHasTemplate(row)).length
    },
    visibleEmploymentRows () {
      return this.filteredRows.filter(row => row.employment)
    },
    tidsbegraensetCount () {
      return this.rows.filter(row => this.isTidsbegraensetRow(row)).length
    },
    areAllVisibleEmploymentsSelected () {
      const selectableRows = this.filteredRows.filter(row => this.isSelectableRow(row))
      return selectableRows.length > 0 && selectableRows.every(row => row.employment ? this.isEmploymentSelected(row.employment.id) : this.isUserWithoutEmploymentSelected(row.user.id))
    },
    selectedCount () {
      return this.selectedEmploymentIds.length + this.selectedUserIdsWithoutEmployments.length
    },
    uniqueNames () {
      const names = this.rows.map(row => row.user.name).filter(name => !!name)
      return this.uniqueSorted(names)
    },
    uniqueGroups () {
      let groups = []
      this.rows.forEach(row => {
        if (row.user.user_tags && row.user.user_tags.length > 0) {
          groups = groups.concat(row.user.user_tags)
        }
      })
      return this.uniqueSorted(groups)
    },
    uniqueEmploymentTitles () {
      const titles = this.rows
        .filter(row => row.employment)
        .map(row => this.employmentTitle(row.employment))
        .filter(title => !!title)
      return this.uniqueSorted(titles)
    },
    employmentsLoading () {
      return this.$store.state.employments.isLoadingEmploymentsTypesForSchool
    },
    isLoading () {
      const initialEmploymentsLoading = !this.employmentsLoadedOnce && this.employmentsLoading
      return this.isLoadingUserYears || initialEmploymentsLoading || (this.poolsDeactivated && this.isLoadingTeachingHours)
    }
  },
  watch: {
    employmentsLoading (loading) {
      if (!loading) {
        this.employmentsLoadedOnce = true
      }
    }
  },
  methods: {
    uniqueSorted (items) {
      const seen = {}
      const unique = []
      items.forEach(item => {
        if (!seen[item]) {
          seen[item] = true
          unique.push(item)
        }
      })
      return unique.sort((a, b) => a.localeCompare(b, 'da-DK'))
    },
    matchesFilters (user) {
      if (this.selectedNames.length > 0 && this.selectedNames.indexOf(user.name) < 0) {
        return false
      }
      if (this.selectedGroups.length > 0) {
        if (!user.user_tags || user.user_tags.length < 1) return false
        return user.user_tags.some(tag => this.selectedGroups.indexOf(tag) > -1)
      }
      return true
    },
    matchesEmploymentTitle (row) {
      if (this.selectedEmploymentTitles.length < 1) return true
      if (!row.employment) return false
      return this.selectedEmploymentTitles.indexOf(this.employmentTitle(row.employment)) > -1
    },
    rowHasTemplate (row) {
      return !!(row.template && row.template.hour_limit)
    },
    matchesTemplateTab (row) {
      if (this.templateTab === 'with') return this.rowHasTemplate(row)
      if (this.templateTab === 'without') return !this.rowHasTemplate(row)
      return true
    },
    toggleName (name) {
      this.toggleInArray(this.selectedNames, name)
    },
    clearNames () {
      this.selectedNames = []
    },
    toggleGroup (group) {
      this.toggleInArray(this.selectedGroups, group)
    },
    clearGroups () {
      this.selectedGroups = []
    },
    toggleEmploymentTitle (title) {
      this.toggleInArray(this.selectedEmploymentTitles, title)
    },
    clearEmploymentTitles () {
      this.selectedEmploymentTitles = []
    },
    closeFilters () {
      this.closeFiltersCount++
    },
    toggleUvHoursSort () {
      if (this.uvHoursSort === 'desc') {
        this.uvHoursSort = 'asc'
      } else if (this.uvHoursSort === 'asc') {
        this.uvHoursSort = null
      } else {
        this.uvHoursSort = 'desc'
      }
    },
    enableBulkMode () {
      this.isBulkMode = true
    },
    disableBulkMode () {
      this.isBulkMode = false
      this.selectedEmploymentIds = []
      this.selectedUserIdsWithoutEmployments = []
    },
    toggleInArray (arr, value) {
      const idx = arr.indexOf(value)
      if (idx > -1) {
        arr.splice(idx, 1)
      } else {
        arr.push(value)
      }
    },
    isEmploymentSelected (employmentId) {
      return this.selectedEmploymentIds.indexOf(employmentId) > -1
    },
    isUserWithoutEmploymentSelected (userId) {
      return this.selectedUserIdsWithoutEmployments.indexOf(userId) > -1
    },
    isRowSelected (row) {
      return row.employment ? this.isEmploymentSelected(row.employment.id) : this.isUserWithoutEmploymentSelected(row.user.id)
    },
    isSelectableRow (row) {
      if (!row.employment && this.isSalaryIntegrationActive) return false
      return !!(row.employment || (!row.employment && row.user))
    },
    toggleEmployment (employment) {
      if (!employment) return
      this.toggleInArray(this.selectedEmploymentIds, employment.id)
    },
    toggleUserWithoutEmployment (user) {
      if (!user) return
      this.toggleInArray(this.selectedUserIdsWithoutEmployments, user.id)
    },
    toggleRow (row) {
      if (!this.isSelectableRow(row)) return
      if (row.employment) {
        this.toggleEmployment(row.employment)
      } else {
        this.toggleUserWithoutEmployment(row.user)
      }
    },
    toggleAllVisibleEmployments () {
      const employmentIds = this.visibleEmploymentRows.map(row => row.employment.id)
      const userIds = this.filteredRows.filter(row => !row.employment && this.isSelectableRow(row)).map(row => row.user.id)
      if (this.areAllVisibleEmploymentsSelected) {
        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(id => employmentIds.indexOf(id) < 0)
        this.selectedUserIdsWithoutEmployments = this.selectedUserIdsWithoutEmployments.filter(id => userIds.indexOf(id) < 0)
        return
      }
      employmentIds.forEach(id => {
        if (!this.isEmploymentSelected(id)) {
          this.selectedEmploymentIds.push(id)
        }
      })
      userIds.forEach(id => {
        if (!this.isUserWithoutEmploymentSelected(id)) {
          this.selectedUserIdsWithoutEmployments.push(id)
        }
      })
    },
    employmentTitle (employment) {
      return employment.source_title ? employment.source_title : employment.title
    },
    templateOptionLabel (template) {
      if (!template.hour_limit) return template.title
      return template.title + '  ·  UV > ' + template.hour_limit
    },
    assignedTeachingHours (userId) {
      if (this.poolsDeactivated) {
        const hours = this.teachingHoursMap[userId]
        return hours != null ? hours : 0
      }
      const userYear = this.userYearMap[userId]
      return userYear && userYear.assigned_teaching_hours ? userYear.assigned_teaching_hours : 0
    },
    normValue (userId, title) {
      const userYear = this.userYearMap[userId]
      const norm = userYear && userYear.norm ? userYear.norm : []
      const found = norm.find(item => item.title === title)
      return found ? found.value : null
    },
    employmentPercentage (userId) {
      const value = this.normValue(userId, 'hidden_ansættelsesgrad')
      return value !== null ? parseFloat(value) : null
    },
    weeklyHours (userId) {
      const percentage = this.employmentPercentage(userId)
      return percentage !== null ? (percentage / 100) * 37 : null
    },
    bruttoTime (userId) {
      const value = this.normValue(userId, 'Bruttotid')
      return value !== null ? parseFloat(value) : null
    },
    periodStart (userId) {
      return this.normValue(userId, 'hidden_periode_start')
    },
    periodEnd (userId) {
      return this.normValue(userId, 'hidden_periode_end')
    },
    ansaettelsesgradIssue (userId) {
      const value = this.employmentPercentage(userId)
      return value === null || value === 0
    },
    bruttotidIssue (userId) {
      const value = this.bruttoTime(userId)
      return value === null || value === 0
    },
    startDateIssue (userId) {
      return !this.periodStart(userId)
    },
    endDateIssue (userId) {
      return !this.periodEnd(userId)
    },
    isAugustFirst (value) {
      if (!value) return false
      const date = moment(value)
      return date.month() === 7 && date.date() === 1
    },
    isJulyLast (value) {
      if (!value) return false
      const date = moment(value)
      return date.month() === 6 && date.date() === 31
    },
    startIsDeviant (row) {
      const start = this.periodStart(row.user.id)
      return !!start && !this.isAugustFirst(start)
    },
    endIsDeviant (row) {
      const end = this.periodEnd(row.user.id)
      return !!end && !this.isJulyLast(end)
    },
    // En tidsbegrænset/afvigende ansættelse har en startdato der ikke er 1/8 eller slutdato der ikke er 31/7.
    // Der skal desuden være tildelt UV-timer og en stillingskategori med en UV-grænse, før der kan beregnes et UV-tillæg.
    isTidsbegraensetRow (row) {
      if (!row.employment) return false
      if (!this.rowHasTemplate(row)) return false
      const start = this.periodStart(row.user.id)
      const end = this.periodEnd(row.user.id)
      if (!start || !end) return false
      if (!(parseFloat(this.assignedTeachingHours(row.user.id)) > 0)) return false
      return this.startIsDeviant(row) || this.endIsDeviant(row)
    },
    openBeregn (row) {
      if (!row.employment) return
      this.beregnRow = row
    },
    onBeregnCreated () {
      this.beregnRow = null
      this.$emit('supplement-created')
    },
    dataIssues (userId) {
      const issues = []
      if (this.ansaettelsesgradIssue(userId)) issues.push('Ansættelsesgrad')
      if (this.bruttotidIssue(userId)) issues.push('Bruttotid')
      if (this.startDateIssue(userId)) issues.push('Startdato')
      if (this.endDateIssue(userId)) issues.push('Slutdato')
      return issues
    },
    hasDataIssues (userId) {
      return this.dataIssues(userId).length > 0
    },
    dataIssuesTitle (userId) {
      const issues = this.dataIssues(userId)
      if (issues.length === 0) return ''
      return 'Mangler data for at kunne hentes med: ' + issues.join(', ')
    },
    formatDecimal (value) {
      const num = parseFloat(value)
      return isNaN(num) ? '—' : num.toFixed(2).replace('.', ',')
    },
    formatDate (value) {
      if (!value) return '—'
      return moment(value).format('DD-MM-YYYY')
    },
    salaryCodeTitle (salaryCodeId) {
      return this.salaryCodeMap[salaryCodeId] || salaryCodeId || '—'
    },
    salaryCodeLoenart (salaryCodeId) {
      const salaryCode = this.salaryCodes.find(sc => String(sc.id) === String(salaryCodeId))
      if (!salaryCode) return salaryCodeId || '—'
      return salaryCode.loenart || salaryCode.code || '—'
    },
    readUserYears () {
      if (!this.schoolId || !this.schoolYearId) return
      this.isLoadingUserYears = true
      docendo.schoolUserYearsList(this.schoolId, this.schoolYearId, null, success => {
        this.userYears = success || []
        this.isLoadingUserYears = false
      }, failure => {
        console.log(failure)
        this.isLoadingUserYears = false
      })
    },
    readTeachingHours () {
      if (!this.schoolId || !this.schoolYearId) return
      this.isLoadingTeachingHours = true
      docendo.readUserHoursForSchoolYear(this.schoolId, this.schoolYearId, null, success => {
        const map = {}
        const rows = (success && success.teaching_hours) || []
        rows.forEach(row => {
          if (row.user_id == null) return
          map[row.user_id] = (map[row.user_id] || 0) + (parseFloat(row.hours) || 0)
        })
        this.teachingHoursMap = map
        this.isLoadingTeachingHours = false
      }, failure => {
        console.log(failure)
        this.isLoadingTeachingHours = false
      }, true)
    },
    setEmploymentTemplate (employment, employmentTemplateId) {
      if (!employmentTemplateId) {
        this.clearEmploymentTemplate(employment)
        return
      }
      this.isSavingTemplateId = employment.id
      docendo.assignEmploymentTemplateToEmployment(
        employment.school_id,
        employmentTemplateId,
        [employment.id],
        success => {
          this.isSavingTemplateId = null
          this.$store.dispatch('readEmployments')
        },
        failure => {
          console.log(failure)
          this.isSavingTemplateId = null
        }
      )
    },
    clearEmploymentTemplate (employment) {
      this.isSavingTemplateId = employment.id
      // Stillingskategorien kopierer vikarløn/lønkode over på ansættelsen – ryd dem når den fjernes.
      docendo.updateEmployment(
        employment.school_id,
        employment.user_id,
        employment.id,
        false,
        null,
        null,
        null,
        null,
        null,
        success => {
          this.isSavingTemplateId = null
          this.$store.dispatch('readEmployments')
          eventbus.toast = {text: 'Stillingskategori er fjernet', success: true, position: 'bottomLeft'}
        },
        failure => {
          console.log(failure)
          this.isSavingTemplateId = null
          eventbus.toast = {text: 'Kunne ikke fjerne stillingskategori', success: false, position: 'bottomLeft'}
        }
      )
    },
    createEmploymentForUser (user, employmentTemplateId) {
      const template = this.employmentTemplateMap[employmentTemplateId]
      if (!template) return
      this.isSavingNewEmploymentUserId = user.id
      docendo.createEmployment(
        this.schoolId,
        user.id,
        null,
        template.title,
        template.id,
        !!template.manual_salary,
        data => {
          this.isSavingNewEmploymentUserId = null
          if (data && data.status === 'error') {
            eventbus.toast = {text: data.message || 'Kunne ikke oprette ansættelse', success: false, position: 'bottomLeft'}
            return
          }
          this.$store.dispatch('readEmployments')
          eventbus.toast = {text: 'Ansættelse er oprettet', success: true, position: 'bottomLeft'}
        },
        failure => {
          console.log(failure)
          this.isSavingNewEmploymentUserId = null
          eventbus.toast = {text: failure && failure.message ? failure.message : 'Kunne ikke oprette ansættelse', success: false, position: 'bottomLeft'}
        }
      )
    },
    assignTemplateToSelected (template) {
      if (this.selectedCount === 0 || !template) return
      this.isSavingBulkTemplates = true
      let pending = 0
      let failed = false

      const finish = () => {
        pending--
        if (pending > 0) return
        this.isSavingBulkTemplates = false
        if (!failed) {
          this.$store.dispatch('readEmployments')
          eventbus.toast = {text: 'Stillingskategori er sat på valgte', success: true, position: 'bottomLeft'}
          this.disableBulkMode()
        }
      }

      const handle = data => {
        if (data && data.status === 'error') {
          failed = true
          eventbus.toast = {text: data.message || 'Kunne ikke sætte stillingskategori på valgte', success: false, position: 'bottomLeft'}
        }
        finish()
      }

      const fail = failure => {
        console.log(failure)
        failed = true
        eventbus.toast = {text: failure && failure.message ? failure.message : 'Kunne ikke sætte stillingskategori på valgte', success: false, position: 'bottomLeft'}
        finish()
      }

      if (this.selectedEmploymentIds.length > 0) {
        pending++
        docendo.assignEmploymentTemplateToEmployment(
          this.schoolId,
          template.id,
          this.selectedEmploymentIds,
          handle,
          fail
        )
      }

      if (this.selectedUserIdsWithoutEmployments.length > 0) {
        pending++
        docendo.bulkCreateEmployment(
          this.schoolId,
          this.selectedUserIdsWithoutEmployments,
          [template.title],
          !!template.manual_salary,
          template.id,
          handle,
          fail
        )
      }
    },
    openCreateTemplate () {
      this.editTemplate = null
      this.isTemplateModalOpen = true
    },
    openEditTemplate (template) {
      this.editTemplate = template
      this.isTemplateModalOpen = true
    },
    closeTemplateModal () {
      this.editTemplate = null
      this.isTemplateModalOpen = false
    },
    onTemplateSaved () {
      this.closeTemplateModal()
      this.$store.dispatch('readEmploymentTemplates')
      this.$store.dispatch('readEmployments')
    }
  },
  mounted () {
    this.$store.dispatch('readEmployments')
    this.$store.dispatch('readEmploymentTemplates')
    this.$store.dispatch('readSalaryCodes')
    this.readUserYears()
    if (this.poolsDeactivated) {
      this.readTeachingHours()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal--full-width {
  width: calc(100vw - 2rem);
}

.d-modal__content {
  padding: 1rem;
  max-height: calc(100vh - 150px);
  overflow: hidden;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
}

.uv-limits__table-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.uv-limits__table-scroll thead {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f6f9fc;
  box-shadow: inset 0 -1px 0 #e3e6ea;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #eee;
}

.uv-limits__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.uv-limits__actions-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.uv-limits__explainer {
  margin: 0;
}

.uv-limits__edit-templates-bttn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 12px;
}

.uv-limits__bulk-submit-bttn {
  font-size: 12px;
}

.uv-limits__templates-dropdown {
  min-width: 240px;
  display: flex;
  flex-direction: column;
  max-height: 60vh;
}

.uv-limits__templates-dropdown__list {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.uv-limits__templates-dropdown__list > li {
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  padding: 0.5rem;
  font-weight: normal;
  position: relative;
}

.uv-limits__templates-dropdown__list > li:hover {
  background-color: #f5f6f7;
  border-radius: 6px;
}

.uv-limits__templates-dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.uv-limits__templates-dropdown__item-title {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.uv-limits__templates-dropdown__item-limit {
  font-size: 11px;
  opacity: 0.6;
}

.uv-limits__templates-dropdown__create {
  flex: 0 0 auto;
  position: sticky;
  bottom: 0;
  margin-top: 0.25rem;
  padding: 1rem;
  border-top: 1px solid var(--border-color);
  background: #fff;
  cursor: pointer;
}

.uv-limits__templates-dropdown__create:hover {
  background-color: #f6f9fc;
}

.uv-limits__templates-dropdown__create .btn-trans {
  width: 100%;
  font-size: 11px;
  font-weight: normal;
  transition: transform 0.25s;
}

.uv-limits__templates-dropdown__create .btn-trans:active {
  transform: scale(0.98);
}

.uv-limits__actions-cell {
  text-align: right;
  white-space: nowrap;
}

.uv-limits__filters .uv-limits__tabs {
  font-size: 0.85rem;
}

.uv-limits__warning {
  color: #e0a800;
  margin-left: 0.4rem;
  cursor: help;
}

.uv-limits__add-employment {
  margin-top: 0.35rem;
}

.uv-limits__add-employment-bttn {
  border: none;
  background: none;
  padding: 0;
  color: var(--blue);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.uv-limits__add-employment-bttn:hover {
  text-decoration: underline;
}

.uv-limits__missing {
  color: #d9534f;
  font-style: italic;
}

.uv-limits__deviant {
  color: #a26206;
  font-weight: 600;
}

.uv-limits__beregn-bttn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 12px;
  color: #a26206;
  border-color: #f0d28a;
  background: #fff8e9;
  white-space: nowrap;
}

.uv-limits__beregn-bttn:hover {
  background: #fdeccb;
}

.uv-limits__beregn-bttn .icon-warning {
  font-size: 13px;
}

.uv-limits__toolbar {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.uv-limits__filters,
.uv-limits__bulk-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.uv-limits__bulk-bar {
  margin-bottom: 0.5rem;
}

.uv-limits__select-cell {
  cursor: pointer;
  width: 36px;
}

.uv-limits__narrow {
  width: 100px;
}

.uv-limits__sortable {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.uv-limits__sortable:hover {
  color: var(--primary);
}

.uv-limits__sort-icon {
  font-size: 10px;
  margin-left: 0.25rem;
  display: inline-block;
  transition: transform 0.15s;
}

.uv-limits__sort-icon--asc {
  transform: rotate(180deg);
}

.uv-limits__sort-icon--muted {
  opacity: 0.35;
}

.uv-limits__secondary {
  opacity: 0.7;
  font-size: 11px;
}

.uv-limits__template-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.uv-limits__row--inactive {
  opacity: .7;
}

.uv-limits__row--selectable {
  cursor: pointer;
}

.uv-limits__row--selectable:hover {
  background: aliceblue;
}

.uv-limits__bulk-bar .do-select {
  min-width: 220px;
}

.uv-limits__row--selectable.is-selected,
.do-table tbody tr.is-selected {
  background-color: #eaf3fb;
}

.do-checkbox {
  border: 1px solid #ccc;
  border-radius: .25rem;
  height: 1rem;
  position: relative;
  width: 1rem;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}

.do-checkbox.do-checkbox--selected {
  background: var(--primary);
  border-color: var(--primary);
}

.do-checkbox.do-checkbox--selected:after,
.do-checkbox.do-checkbox--selected:before {
  background: #fff;
}

.do-checkbox:after,
.do-checkbox:before {
  background: transparent;
  transform: rotate(35deg);
}

.do-checkbox:after {
  height: 8px;
  right: 3px;
  top: 1px;
  width: 1.5px;
}

.do-checkbox:after,
.do-checkbox:before {
  border-radius: 1rem;
  content: "";
  display: block;
  position: absolute;
}

.do-checkbox.do-checkbox--selected:before {
  bottom: 2.5px;
  height: 1.5px;
  right: 5px;
  width: 4px;
}

.muted {
  opacity: 0.6;
}

.uv-limits__bulk-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.uv-limits__bulk-bar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__header {
  margin-bottom: 0;
}

.do-badge {
  background: #f4f4f5;
  border-radius: 4px;
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  padding: .15rem .35rem;
}

.do-badge--yellow {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: #fff8e9;
  color: #a26206;
  border: 1px solid #f0d28a;
  font-weight: 600;
  padding: 0.35rem 0.6rem;
  cursor: help;
}

.do-badge--yellow .icon-warning {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// UvLimitsModal.vue?6e1b0185